export default "__VITE_ASSET__DKtVgDaj__"